/**
 * Strip null values from an object recursively.
 * WebAuthn API treats null differently from undefined - null values can cause
 * the browser to behave unexpectedly (e.g., not showing password managers).
 */
export const stripNulls = <T extends object>(obj: T): T => {
    return Object.fromEntries(
        Object.entries(obj)
            .filter(([, v]) => v !== null)
            .map(([k, v]) =>
                v && typeof v === 'object' && !Array.isArray(v)
                    ? [k, stripNulls(v)]
                    : [k, v]
            )
    ) as T;
};
